/**
 * Transforms the segment API's representation into
 * a representation suitable for the UI
 */
export function unserialize(apiSegment) {
  const segment = {};
  segment.id = apiSegment.id;
  segment.created = apiSegment.created;
  segment.name = apiSegment.name;
  const rangeFilters = apiSegment.rangeFilters.map(filter => {
    const unserializedFilter = {
      attribute: filter.attribute,
      typeRange: filter.typeRange,
      typeDate: filter.typeDate
    };
    if (filter.typeRange === 'BETWEEN') {
      unserializedFilter.fromValue = filter.betweenFromValue;
      unserializedFilter.toValue = filter.betweenToValue;
    } else {
      unserializedFilter.fromValue = filter.value;
    }
    return unserializedFilter;
  });
  const booleanFilters = apiSegment.booleanFilters.map(filter => {
    return {
      attribute: filter.attribute,
      typeRange: filter.typeBoolean,
      // Tal cual se guardó: el catálogo usa minúsculas (owner, true).
      fromValue: filter.value
    };
  });
  segment.filters = [...rangeFilters, ...booleanFilters];
  return segment;
}

/**
 * Catálogo de townhall a lo que usa el formulario de segmentos: id para las
 * keys, nombre visible (si falta, el atributo) y el código de cada valor en
 * Value, que es lo que lee el formulario (townhall manda value; Value se va).
 */
export function normalizeCatalog(catalog) {
  return (Array.isArray(catalog) ? catalog : [])
    .filter(item => item && item.attribute)
    .map(item => ({
      id: item.id || item.attribute,
      attribute: item.attribute,
      attributeName: item.attributeName || item.attribute,
      type: item.type || 'BOOLEAN',
      values: (item.values || []).map(value => {
        // value es el oficial; Value queda mientras townhall manda los dos.
        const code = value.value != null ? value.value : value.Value;
        return { id: value.id || code, name: value.name || code, Value: code };
      })
    }));
}
